<style>
.v-label,
.v-select__selections {
  font-size: 12px !important;
}
.marginLeft {
  margin-left: 22px;
}
</style>

<template>
  <div style="height: 85%">
    <ExportTableData
      ref="pobierz"
      :column-defs="columnDefs"
      :grid-options="gridOptions"
    ></ExportTableData>
    <v-layout>
      <v-flex xs7>
        <v-layout class="table--first-row" row wrap>
          <v-flex class="table__wrapper--center">
            <v-icon
              class="table__btn--blue"
              v-show="selectedRow"
              @click="openHydrantCard"
              >note</v-icon
            >
            <p class="caption" v-show="selectedRow" @click="openHydrantCard">
              OTWÓRZ KARTĘ
            </p>
            <template v-if="!isShowActive">
              <v-icon
                :class="{ marginLeft: selectedRow }"
                class="table__btn--blue"
                title="Pokaż hydranty z datą ostatniej inspekcji starszą niż bieżący rok kalendarzowy"
                @click="showActive"
                >timer</v-icon
              >
              <p
                class="caption"
                title="Pokaż hydranty z datą ostatniej inspekcji starszą niż bieżący rok kalendarzowy"
                @click="showActive"
              >
                STARSZE PRZEGLĄDY
              </p>
            </template>
            <template v-else>
              <v-icon
                :class="{ marginLeft: selectedRow }"
                class="table__btn--blue"
                @click="showActive"
                title="Wyłącz filtrowanie po dacie inspekcji"
                >timer_off</v-icon
              >
              <p
                class="caption"
                title="Wyłącz filtrowanie po dacie inspekcji"
                @click="showActive"
              >
                POKAŻ WSZYSTKIE
              </p>
            </template>
          </v-flex>
          <v-spacer />
        </v-layout>
        <v-layout row wrap>
          <v-flex class="table__wrapper--center">
            <v-icon
              @click="
                'pobierz' in $refs && $refs.pobierz.showExportMenu($event)
              "
              class="table__btn--blue"
              >cloud_download</v-icon
            >
            <p
              class="caption"
              @click="
                'pobierz' in $refs && $refs.pobierz.showExportMenu($event)
              "
            >
              POBIERZ REJESTR
            </p>
            <v-icon
              class="table__btn--padding"
              @click="zoomToFeature"
              v-show="selectedRow"
              >zoom_in</v-icon
            >
            <p class="caption" @click="zoomToFeature" v-show="selectedRow">
              PRZYBLIŻ
            </p>
          </v-flex>
          <v-spacer />
        </v-layout>
      </v-flex>
      <v-flex xs5 class="table__wrapper--center table__wrapper--filter">
        <v-layout align-right justify-end>
          <v-select
            :items="statuses"
            label="Filtr: status"
            v-model="filterStatus"
            hide-details
            clearable
            @change="filterByStatus(filterStatus)"
            style="padding-right:10px;"
          ></v-select>
          <v-text-field
            type="text"
            v-model="filter"
            placeholder="Treść filtra"
            clearable
            :hint="numberFiltered + '/' + numberAll"
            persistent-hint
            filled
          >
          </v-text-field>
        </v-layout>
      </v-flex>
    </v-layout>

    <ag-grid-vue
      style="width: 100%; height: 90%;"
      class="ag-theme-balham"
      :gridOptions="gridOptions"
    ></ag-grid-vue>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import ExportTableData from "../../shared/ExportTableData";

export default {
  name: "App",
  data: () => ({
    filter: "",
    filterStatus: "",
    numberAll: "0",
    numberFiltered: "0",
    selectedRow: undefined,
    statuses: [],
    tableTitle: "hydrantsTable",
    date_now: new Date(),
    isShowActive: false
  }),
  components: {
    AgGridVue,
    ExportTableData
  },
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    gridOptions() {
      let gridOptions = {
        columnDefs: this.columnDefs,
        enableSorting: "true",
        enableFilter: "true",
        enableColResize: "true",
        localeText: {
          contains: "Zawiera",
          notContains: "Nie zawiera",
          equals: "Równa się",
          notEqual: "Nie równa się",
          startsWith: "Zaczyna się",
          endsWith: "Kończy się",
          noRowsToShow: "Brak danych"
        },
        onGridReady: this.onGridReady,
        onColumnMoved: this.onColumnMoved,
        onColumnResized: this.onColumnMoved,
        onSelectionChanged: this.onSelectionChanged,
        onFilterChanged: this.filterColumn,
        overlayLoadingTemplate:
          '<span class="ag-overlay-loading-center">Trwa ładowanie danych</span>',
        rowData: this.loadData(),
        rowSelection: "single"
      };
      return gridOptions;
    },
    hydrants() {
      return this.$store.getters.getHydrants;
    },
    layerProperties() {
      return this.$store.getters.getLayers.find(
        layer => layer.full_type === "hydrants"
      );
    },
    srid() {
      return this.$store.getters.getSrid;
    }
  },
  watch: {
    filter(nV) {
      this.gridOptions.api.setQuickFilter(nV);
      this.numberFiltered = this.gridOptions.api.getModel().rootNode.childrenAfterFilter.length;
    }
  },
  beforeMount() {
    const dateGetter = function(data, prop) {
      if (data.data.properties[prop] !== null) {
        return new Date(data.data.properties[prop]);
      }
      return null;
    };
    const dateComparator = function(filterLocalDateAtMidnight, cellValue) {
      if (cellValue === null) return -1;
      if (!cellValue) return 0;
      if (cellValue < filterLocalDateAtMidnight) {
        return -1;
      } else if (cellValue > filterLocalDateAtMidnight) {
        return 1;
      } else {
        return 0;
      }
    };
    this.columnDefs = [
      {
        headerName: "ID",
        field: "properties.id",
        sort: "asc",
        width: 100
      }
    ];
    this.layerProperties.fields.forEach(field => {
      let property;
      if (
        field.name != "id" &&
        (field.name == "measure_date" ||
          field.name == "next_inspection_date" ||
          field.name == "last_inspection_date")
      ) {
        property = {
          headerName: field.display_name,
          field: "properties." + field.name,
          valueGetter: data => dateGetter(data, field.name),
          cellRenderer: date => {
            if (date.value != null) {
              return new Date(date.value).toLocaleString("pl-PL", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit"
              });
            } else {
              return "Brak przypisanej daty";
            }
          },
          filter: "agDateColumnFilter",
          filterParams: {
            comparator: (filterLocalDateAtMidnight, cellValue) =>
              dateComparator(filterLocalDateAtMidnight, cellValue),
            browserDatePicker: true
          }
        };
      } else if (field.name != "id") {
        property = {
          headerName:
            field.display_name.slice(0, 5) == "Addr_"
              ? field.display_name.slice(5).replace(/_/g, " ")
              : field.display_name,
          field: "properties." + field.name
        };
      }
      this.columnDefs.push(property);
    });
  },
  methods: {
    filterColumn() {
      this.numberFiltered = this.gridOptions.api
        .getModel()
        .rootNode.childrenAfterFilter.length.toString();
    },
    editInspection() {
      if (this.gridOptions && this.gridOptions.api) {
        let selectedHydrants = this.gridOptions.api
          .getSelectedRows()
          .map(element => {
            return element.id;
          });
        this.$store.commit("setSelectedHydrantsEdited", selectedHydrants);
        this.$modal.hide("HydrantsRegisterInspection");
      }
    },
    filterByStatus(value) {
      let statusFilter = this.gridOptions.api.getFilterInstance(
        "properties.status"
      );
      statusFilter.setModel({
        type: "equals",
        filter: value
      });
      this.gridOptions.api.onFilterChanged();
      this.numberFiltered = this.gridOptions.api.getModel().rootNode.childrenAfterFilter.length;
    },
    filterByInspection() {
      this.gridOptions.api.setQuickFilter(
        document.getElementById("filter-text-box").value
      );
    },
    onColumnMoved(params) {
      const columnState = JSON.stringify(
        this.gridOptions.columnApi.getColumnState()
      );
      localStorage[this.tableTitle] = columnState;
    },
    openHydrantCard() {
      let payload = {
        object_id: this.selectedRow.id,
        object_table: "hydrants",
        object_type: "layers",
        limit: 5,
        events_count: true
      };
      this.$store.dispatch("getFeature", payload).then(success => {
        this.$store.commit("setHydrantData", success);
        if (success) {
          this.$root.$emit(
            "setInspectionDates",
            success.values_.last_inspection_date
          );
          this.$root.$emit("loadHydrantData", success);
          this.$store.dispatch("getFeatureEvents", payload).then(success => {
            if (success) {
              this.show("hydrantCardModal");
            } else {
              this.$root.$emit(
                "showSnackbar",
                "red",
                "Podczas pobierania danych hydrantu wystąpił błąd"
              );
            }
          });
        } else {
          this.$root.$emit(
            "showSnackbar",
            "red",
            "Podczas pobierania danych hydrantu wystąpił błąd"
          );
        }
      });
    },
    loadData() {
      this.$store
        .dispatch("getFeatures", {
          layername: "hydrants",
          srid: this.$store.getters.getSrid
        })
        .then(success => {
          if (success) {
            this.$store.commit("setHydrants", success);
            this.numberAll = this.hydrants.features.length;
            this.numberFiltered = this.numberAll;
            if (this.gridOptions && this.gridOptions.api) {
              this.gridOptions.api.setRowData(this.hydrants.features);
            }
          }
        });

      let payload = {
        schema: "aquagis",
        table: "hydrants",
        column: "status"
      };
      this.$store.dispatch("getDictSTC", payload).then(r => {
        this.statuses = r.values;
      });
    },
    onGridReady(params) {
      if (localStorage[this.tableTitle]) {
        const columnState = JSON.parse(localStorage[this.tableTitle]);
        if (columnState) {
          this.gridOptions.columnApi.setColumnState(columnState);
        }
      }
    },
    onSelectionChanged() {
      this.selectedRow = this.gridOptions.api.getSelectedRows()[0];
    },
    show(title) {
      if (this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    showActive() {
      if (!this.isShowActive) {
        this.isShowActive = true;
        let inspectionFilter = this.gridOptions.api.getFilterInstance(
          "last_inspection_date"
        );
        inspectionFilter.setModel({
          type: "lessThan",
          dateFrom: `${this.date_now.getFullYear()}-01-01`,
          dateTo: null
        });
        this.gridOptions.api.onFilterChanged();
        this.numberFiltered = this.gridOptions.api.getModel().rootNode.childrenAfterFilter.length;
      } else {
        this.isShowActive = false;
        this.gridOptions.api.setFilterModel(null);
        this.numberFiltered = this.gridOptions.api.getModel().rootNode.childrenAfterFilter.length;
      }
    },
    zoomToFeature() {
      this.$root.$emit("zoomToFeature", this.selectedRow, {
        srid: this.srid
      });
    }
  },
  mounted() {
    /* this.$root.$on("addInspection", this.addInspection);
    this.$root.$on("editInspection", this.editInspection); */
    this.$root.$on("edited_hydrant", this.loadData);
    this.$root.$on("edited_inspection", this.loadData);
  },
  destroyed() {
    this.$root.$off("edited_hydrant", this.loadData);
    this.$root.$off("edited_inspection", this.loadData);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/table/HydrantsTable.vue